import { Flex, Layout, Text } from '@servicetitan/anvil2';

interface PlaceholderProps {
    title: string;
}

// Convert object with key-value pairs to a table; values are stringified if they are objects themselves, otherwise they are displayed as is
const formatObjectToTable = (obj: Record<string, any>) => {
    return Object.entries(obj).map(([key, value]) => {
        let parsedValue;
        try {
            parsedValue = JSON.parse(value);
        } catch {
            parsedValue = value;
        }

        return (
            <table key={key}>
                <thead>
                    <tr>
                        <th colSpan={2}>{key}</th>
                    </tr>
                </thead>
                <tbody>
                    {typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? (
                        Object.entries(parsedValue).map(([subKey, subValue]) => (
                            <tr key={subKey}>
                                <th style={{ textAlign: 'left' }}>{subKey}</th>
                                <td>
                                    {typeof subValue === 'object'
                                        ? 'object'
                                        : Array.isArray(subValue)
                                          ? subValue.join(', ')
                                          : typeof subValue === 'string'
                                            ? subValue
                                            : JSON.stringify(subValue)}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={2}>{parsedValue}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    });
};

export const Placeholder = ({ title, ...props }: PlaceholderProps) => {
    return (
        <Layout>
            <Layout.Item>
                <Flex
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    style={{ height: '100vh' }}
                >
                    <Text variant="headline" el="h2">
                        {title} Placeholder
                    </Text>
                    <Flex
                        justifyContent="flex-start"
                        style={{ width: '66%', marginTop: 16 }}
                        direction="column"
                    >
                        {formatObjectToTable(props)}
                    </Flex>
                </Flex>
            </Layout.Item>
        </Layout>
    );
};
